import { useState, useEffect } from 'react';

import Icon from '../../components/AppIcon';
import ProfileSection from './components/ProfileSection';
import ConnectedAccountsSection from './components/ConnectedAccountsSection';
import NotificationPreferences from './components/NotificationPreferences';
import SecuritySection from './components/SecuritySection';
import TeamManagementSection from './components/TeamManagementSection';
import DataManagementSection from './components/DataManagementSection';
import BillingSection from './components/BillingSection';

const AccountSettings = () => {
  const [activeTab, setActiveTab] = useState('profile');

  useEffect(() => {
    // Check URL parameters for tab selection
    const params = new URLSearchParams(window.location?.search);
    const tab = params?.get('tab');
    if (tab && ['profile', 'accounts', 'notifications', 'security', 'team', 'data', 'billing']?.includes(tab)) {
      setActiveTab(tab);
    }
  }, []);

  const tabs = [
    { id: 'profile', label: 'Profile', icon: 'User' },
    { id: 'accounts', label: 'Connected Accounts', icon: 'Link' },
    { id: 'notifications', label: 'Notifications', icon: 'Bell' },
    { id: 'security', label: 'Security', icon: 'Shield' },
    { id: 'team', label: 'Team', icon: 'Users' },
    { id: 'data', label: 'Data Management', icon: 'Database' },
    { id: 'billing', label: 'Billing', icon: 'CreditCard' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return <ProfileSection />;
      case 'accounts':
        return <ConnectedAccountsSection />;
      case 'notifications':
        return <NotificationPreferences />;
      case 'security':
        return <SecuritySection />;
      case 'team':
        return <TeamManagementSection />;
      case 'data':
        return <DataManagementSection />;
      case 'billing':
        return <BillingSection />;
      default:
        return <ProfileSection />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <main className="main-content">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">Account Settings</h1>
            <p className="text-muted-foreground">
              Manage your profile, security, and preferences
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-6">
            <aside className="lg:w-64 flex-shrink-0">
              <nav className="bg-card rounded-lg border border-border p-2 sticky top-20">
                {tabs?.map((tab) => (
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all ${
                      activeTab === tab?.id
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                    }`}
                  >
                    <Icon name={tab?.icon} size={18} />
                    <span>{tab?.label}</span>
                  </button>
                ))}
              </nav>
            </aside>

            <div className="flex-1 min-w-0">
              {renderTabContent()}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AccountSettings;